
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"1em","height":"1em","fill":"currentColor","viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M8.576 3.976A2.5 2.5 0 0111.021 2h1.958a2.5 2.5 0 012.444 1.976l.463 2.157A3.001 3.001 0 0118 9v1.085a1.5 1.5 0 011 1.415v1a1.5 1.5 0 01-1 1.415V15c0 1.349-.89 2.49-2.114 2.867l-.462 2.157A2.5 2.5 0 0112.979 22h-1.958a2.5 2.5 0 01-2.445-1.976l-.462-2.157A3.001 3.001 0 016 15V9c0-1.349.89-2.49 2.114-2.867l.462-2.157zM16 9a1 1 0 00-1-1H9a1 1 0 00-1 1v6a1 1 0 001 1h6a1 1 0 001-1V9z"}}),_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M10 13a1 1 0 100-2 1 1 0 000 2zM14 13a1 1 0 100-2 1 1 0 000 2zM12 11a1 1 0 100-2 1 1 0 000 2zM12 15a1 1 0 100-2 1 1 0 000 2z"}})])
          )
        }
      }
    